// removed by extract-text-webpack-plugin
module.exports = {"container":"Footer-container","row":"Footer-row"};